import { Checkbox, TableCell, TableRow } from "@mui/material";
import { DotLegalDialog, DotLegalHeader, DotLegalMultiSelect, DotLegalTable, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { SelectableCatalogRow, useRiskConsequenceCatalogDialogDataMapping } from "./RiskConsequenceCatalogDialog.hooks";
import DialogHeaderWithInformation from "@common/components/dialogHeaderWithInformation/DialogHeaderWithInformation";

export interface IRiskConsequenceCatalogDialog {
    onHideDialog: () => void;
    onImported: () => void;
}

function RiskConsequenceCatalogDialog(props: IRiskConsequenceCatalogDialog) {
    const { translateString } = useTranslation();
    const {
        isLoading,
        rows,
        toggleEntry,
        onSelectAllChanged,
        getHeaderCheckBoxState,
        riskAreaOptions,
        riskAreasLoading,
        getChosenRiskAreas,
        setRiskAreas,
        hasSelection,
        inProgress,
        importSelected,
    } = useRiskConsequenceCatalogDialogDataMapping(props);

    const headers: Array<ITableHeader<SelectableCatalogRow>> = [
        { property: "name", text: translateString("riskConsequence"), align: "left", showOnMobile: true },
        { property: "categoryLabel", text: translateString("category"), align: "left", showOnMobile: true },
        { property: "riskAreas", text: translateString("riskAreas"), align: "left", showOnMobile: true, notSortable: true, width: "500px" },
    ];

    return (
        <DotLegalDialog
            open
            isLoading={isLoading}
            inProgress={inProgress}
            okButtonDisabled={!hasSelection}
            header={
                <DialogHeaderWithInformation header={translateString("riskConsequenceCatalog")} information={translateString("riskConsequenceCatalogInfo")} />
            }
            buttonOkText={translateString("import")}
            onOkClick={importSelected}
            onDialogClose={props.onHideDialog}
            size="xl"
        >
            <DotLegalTable
                headers={headers}
                data={rows}
                isLoading={isLoading}
                defaultOrderBy="name"
                defaultOrder="asc"
                hidePagination
                clickableRows={false}
                onSelectAllChanged={onSelectAllChanged}
                headerCheckBoxState={getHeaderCheckBoxState()}
                emptyText={translateString("noOptions")}
                renderRow={(row) => (
                    <TableRow key={row.entry} hover sx={{ cursor: "pointer" }} onClick={() => toggleEntry(row.entry)}>
                        <TableCell padding="checkbox">
                            <Checkbox checked={row.isSelected} readOnly tabIndex={-1} />
                        </TableCell>
                        <TableCell>
                            <DotLegalHeader marginBottom={0} headerStyle="extraSmall" fontWeight={400} toolTip={row.description}>
                                {row.name}
                            </DotLegalHeader>
                        </TableCell>
                        <TableCell>{row.categoryLabel}</TableCell>
                        <TableCell sx={{ width: 500 }} onClick={(event) => event.stopPropagation()}>
                            {row.isSelected && (
                                <DotLegalMultiSelect
                                    label=""
                                    noMargin
                                    options={riskAreaOptions}
                                    chosenOptions={getChosenRiskAreas(row.entry)}
                                    onChange={(values) => setRiskAreas(row.entry, values)}
                                    isLoading={riskAreasLoading}
                                    noOptionsLabel={translateString("noOptions")}
                                    variant="standard"
                                    disableClearable
                                />
                            )}
                        </TableCell>
                    </TableRow>
                )}
            />
        </DotLegalDialog>
    );
}

export default RiskConsequenceCatalogDialog;
